import { WeekSchedule } from 'models/week-schedule';
import { Reducer } from 'redux';

import {
  GET_WEEK_SCHEDULE,
  SELECT_LIST,
  WeekScheduleActions,
  SET_DAY,
  REVERSE_CHANGES,
  TOGGLE_LIST,
} from './week-schedule.types';

export interface WeekScheduleState {
  isListDay: boolean;
  isListMoments: boolean;
  listMoments: Array<Array<string | number>>;
  backupListMoments: Array<Array<string | number>>;
  listDay: Array<Array<string | number>>;
  backupListDay: Array<Array<string | number>>;
  tableData: Array<Array<WeekSchedule>>;
  backupTableData: Array<Array<WeekSchedule>>;
  firstDay: number;
  secondDay: number;
  city: string;
  moments: Array<string>;
  weekOrder: Array<string>;
  colors: { [key: string]: string };
}

const initialSettings: WeekScheduleState = {
  isListDay: false,
  isListMoments: false,
  listDay: [],
  backupListDay: [],
  listMoments: [],
  backupListMoments: [],
  tableData: [],
  backupTableData: [],
  firstDay: -1,
  secondDay: -1,
  colors: { '': '' },
  city: '',
  weekOrder: [],
  moments: [],
};

const weekScheduleReducer: Reducer<WeekScheduleState, WeekScheduleActions> = (
  state: WeekScheduleState = initialSettings,
  action: WeekScheduleActions,
) => {
  switch (action.type) {
    case GET_WEEK_SCHEDULE:
    case SELECT_LIST:
    case TOGGLE_LIST:
    case SET_DAY:
    case REVERSE_CHANGES:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default weekScheduleReducer;
